module.exports = __webpack_public_path__ + "img/icon-linked-file-asset.b6de8996.svg";